import { computed, ComputedRef } from 'vue'

import { Participant } from '@collector/sportsapi-client'

import { useEventSettings } from './useEventSettings'
import { useParticipants } from './useParticipants'

export function useInvertedParticipants(): {
  invertedParticipants: ComputedRef<boolean>
  firstParticipant: ComputedRef<Participant | undefined>
  secondParticipant: ComputedRef<Participant | undefined>
} {
  const { eventSettings } = useEventSettings()
  const { homeParticipant, awayParticipant } = useParticipants()

  const invertedParticipants = computed(
    () => eventSettings.value.invertedParticipants ?? false,
  )

  const firstParticipant = computed(() =>
    invertedParticipants.value ? awayParticipant.value : homeParticipant.value,
  )

  const secondParticipant = computed(() =>
    invertedParticipants.value ? homeParticipant.value : awayParticipant.value,
  )

  return {
    invertedParticipants,
    firstParticipant,
    secondParticipant,
  }
}
